<template>
  <div>
    <Registerlayout>
        <form @submit.prevent="verifyotp()">
      <div class="form-group">
        <h5>
          We’ve sent a Five-digit confirmation code 
          <strong class="text-bold">.</strong> Enter it below to Verify your
          mobile number & Email id.
        </h5>
        <label class="mt-3" for="email">Email Otp</label>
        <input
          type="text"
          class="form-control"
          placeholder="Enter OTP"
          v-model="emailotp"
          id="email"
        />
        <label class="mt-3" for="email">Mobile Otp</label>
        <input
          type="text"
          class="form-control mb-3"
          placeholder="Enter OTP"
          v-model="mobileotp"
          id="email"
        />
        <a href="javascript:void(0);" class="link-danger" @click="resendotp()">Resend Otp</a>
        <button class="btn_1 rounded full-width mt-4"> Verify</button>
      </div>
      </form>
    </Registerlayout>
  </div>
</template>
<script>
import Registerlayout from "../layouts/Registerlayout.vue";
import API from "../services/index";
export default {
  name: "Verify",
  components: { Registerlayout },
  data(){
    return{
        emailotp:"",
        mobileotp:"",
        user_id: null
    }
  },
  mounted() {
    // console.log(this.route.params.id);
            API.get(`User/info?email=${this.$route.params.id}`)
            .then( (response)=>{
             this.user_id = response.data[0].id;
            }).catch(function (error) {
              console.log(error);
            })
  },
  methods: {
    verifyotp(){
        const form = new FormData();
        form.append("mobileotp", this.mobileotp);
        form.append("emailotp", this.emailotp);
        form.append("id", window.btoa(this.user_id));
        API.post(`User/verify`, form,).then((res)=>{
            if(res.data.status === 200){
                this.$swal("Success", res.data.messages);
                this.$router.push("/signin");
            }else{
            this.$swal("Error", res.data.messages);

            }
            console.log(res.data)
        }).catch((err)=>{
            console.log(err);
        })
    },
    resendotp(){
      const form = new FormData();
        form.append("id", window.btoa(this.user_id));
        API.post(`User/resendotp`, form,).then((res)=>{
            if(res.data.status === 200){
                this.$swal("Success", res.data.messages);
            }else{
            this.$swal("Error", res.data.messages);

            }
            console.log(res.data)
        }).catch((err)=>{
            console.log(err);
        })
    }
  }
};
</script>